import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

Sentry.init({
  debug:
    import.meta.env.MODE === "acceptance" ||
    import.meta.env.MODE === "go" ||
    import.meta.env.MODE === "development",
  dsn: import.meta.env.VITE_SENTRY_DSN, // Set in build.sh
  environment: "portal",
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: false, // TODO: Use class names to unmask text as needed, see https://docs.sentry.io/platforms/javascript/session-replay/privacy/#privacy-configuration
      blockAllMedia: false,
    }),
    Sentry.captureConsoleIntegration({
      levels: ["error", "warn"],
    }),
  ],

  tracesSampleRate: 1.0, // Capture 100% of transactions

  replaysSessionSampleRate: 0.1, // Capture Replay for 10% of all sessions,
  replaysOnErrorSampleRate: 1.0, // Capture Replay for 100% of errors
});

// Based on https://docs.sentry.io/platforms/javascript/guides/react-router/troubleshooting/#capturing-resource-404s
document.body.addEventListener(
  "error",
  (event) => {
    if (!event.target) return;

    if ((event.target as HTMLElement).tagName === "IMG") {
      Sentry.captureException(
        new Error(
          `Failed to load image: ${(event.target as HTMLImageElement).src}`,
        ),
      );
      return;
    }

    if ((event.target as HTMLElement).tagName === "LINK") {
      Sentry.captureException(
        new Error(
          `Failed to load css: ${(event.target as HTMLLinkElement).href}`,
        ),
      );
      return;
    }
  },
  true, // useCapture - necessary for resource loading errors
);
